module.exports = __webpack_public_path__ + "img/birthdays-for-good.4763d043.png";